//商务合作链接
export const BusCooperation = "https://tally.so/r/mKyvNK";
//购票链接
export const BuyTicket = "https://9424105689699.huodongxing.com/event/7808935150100";
//成为嘉宾
export const toSpeaker = "https://tally.so/r/w85AyY"